<template>
	<div 
	class="row border-15"
	style="
		display: flex;
    	align-items: center;
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		"
	:style="'background-image: url('+require('../../../assets/img/bg_light_orange.svg')+');'"
	dir="ltr"
	>
		<div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-center p-5">
			<h2
				class="bMikhak text-success"
				:class="(windowWidth < 990) ? 'text-center' : ''"
				data-aos="fade-up"
				data-aos-duration="3000"
			>
				دعوت به همکاری از مدرسان، مربیان و اساتید
			</h2>
			<p
				class='text-justify rtl'
				data-aos="fade-up"
				data-aos-duration="3000"
			>
				مدرس ها و مربیان مقاطع و رشته های تحصیلی و غیرتحصیلی مختلف می‌توانند صفحه ی اختصاصی خود را در ایزی تیک داشته باشند و به مدیریت کلاس های تدریس خصوصی خود بصورت آنلاین و حضوری بپردازند.
			</p>
			<div class="row" dir="rtl">
				<div class="col-sm-12 col-md-12 col-lg-5 col-xl-5">
					<router-link to="/signupTeacher">
						<btn
							type="success"
							text="درخواست همکاری"
							textClass="w-100"
						/>
					</router-link>
				</div>
				<div class="col-sm-12 col-md-12 col-lg-5 col-xl-5" :class="(windowWidth < 990) ? 'mt-3' : ''">
					<router-link to="/aboutme">
						<btn
							dir="rtl"
							class=""
							type="outline-success"
							text="بیشتر بدانید"
							textClass="text-white w-100"
							
							:img="require('../../../assets/img/Arrow_Left.svg')"
						/>
					</router-link>
				</div>
			</div>
			<!-- <router-link to="/signupTeacher">
				<btn
					type="success"
					text="درخواست همکاری"
				/>
			</router-link>
			<router-link to="/aboutme" class="float-right">
				<btn
					dir="rtl"
					class="float-right"
					type="outline-success mr-3"
					text="بیشتر بدانید"
					textClass="text-white"
					:img="require('../../../assets/img/Arrow_Left.svg')"
				/>
			</router-link> -->
		</div>
		<div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-center p-3">
			<img
					class="w-75 mt-3"
					:src="require('../../../assets/img/Illustration_Home_3.svg')"
					data-aos="fade-up"
					data-aos-duration="3000"
					alt="دعوت به همکاری از مدرسان، مربیان و اساتید"
					title="دعوت به همکاری از مدرسان، مربیان و اساتید"
				/>
		</div>
	</div>
</template>

	<script>
		import btn from  "../../../UI/button/btn.vue";
		export default {
			name: 'p_home3',
			data(){
				return {
				}
			},
			components: {
				btn,
			},
			props: [],
			mounted(){

			},
			methods:{

			}
		}
	</script>
<style>
.bg-success {
    background-color: #1b60c6 !important;
}
</style>
